/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type ImportEvidenceMutationVariables = Types.Exact<{
  object: Types.ImportEvidenceInput;
}>;

export type ImportEvidenceMutation = { __typename?: 'mutation_root'; import_evidence: string };

export type ImportEvidenceToControlsMutationVariables = Types.Exact<{
  object: Types.ImportEvidenceToControlsInput;
}>;

export type ImportEvidenceToControlsMutation = {
  __typename?: 'mutation_root';
  import_evidence_to_controls: string;
};

export const ImportEvidenceDocument = `
    mutation ImportEvidence($object: ImportEvidenceInput!) {
  import_evidence(object: $object)
}
    ` as string & TypedDocumentNode<ImportEvidenceMutation, ImportEvidenceMutationVariables>;
export const ImportEvidenceToControlsDocument = `
    mutation ImportEvidenceToControls($object: ImportEvidenceToControlsInput!) {
  import_evidence_to_controls(object: $object)
}
    ` as string &
  TypedDocumentNode<ImportEvidenceToControlsMutation, ImportEvidenceToControlsMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ImportEvidence: build.mutation<ImportEvidenceMutation, ImportEvidenceMutationVariables>({
      query: (variables) => ({ document: ImportEvidenceDocument, variables }),
    }),
    ImportEvidenceToControls: build.mutation<
      ImportEvidenceToControlsMutation,
      ImportEvidenceToControlsMutationVariables
    >({
      query: (variables) => ({ document: ImportEvidenceToControlsDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useImportEvidenceMutation, useImportEvidenceToControlsMutation } = injectedRtkApi;
